var map = {
	"./cake.webp": 1814,
	"./crown-blue.webp": 1815,
	"./crown.webp": 1816,
	"./pocket.webp": 1817,
	"./present.webp": 1818,
	"./relegation.webp": 1819,
	"./t-deposit.webp": 1820,
	"./t-turnover.webp": 1821,
	"./vip-bg.webp": 1822,
	"./vip1.gif": 1823,
	"./vip1.webp": 1824,
	"./vip10-bg.webp": 1825,
	"./vip10.gif": 1826,
	"./vip10.webp": 1827,
	"./vip11-bg.webp": 1828,
	"./vip11.gif": 1829,
	"./vip11.webp": 1830,
	"./vip12-bg.webp": 1831,
	"./vip12.gif": 1832,
	"./vip12.webp": 1833,
	"./vip2.gif": 1834,
	"./vip2.webp": 1835,
	"./vip3.gif": 1836,
	"./vip3.webp": 1837,
	"./vip4.gif": 1838,
	"./vip4.webp": 1839,
	"./vip5.gif": 1840,
	"./vip5.webp": 1841,
	"./vip6.gif": 1842,
	"./vip6.webp": 1843,
	"./vip7.gif": 1844,
	"./vip7.webp": 1845,
	"./vip8.gif": 1846,
	"./vip8.webp": 1847,
	"./vip9.gif": 1848,
	"./vip9.webp": 1849
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 448;